import Vue from "vue";
import Element from "element-ui";
import i18n from "_private/lang"; // Internationalization
import "./variables.scss";

Vue.use(Element, {
    size: "mini", // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
});
